import React from 'react'
import MainDetail from './MainDetail'
import RelatedProduct from './RelatedProduct'

const ProductDetail = () => {
  return (
    <div>
      <MainDetail />
      <RelatedProduct />
    </div>
  )
}

export default ProductDetail
